<template>
  <div class="news">
    <banner title="" />
    <div class="news-section webContainer" v-loading="loading">
      <div class="news-section-content formMiddleCenter">

        <div style="text-align: center;"><span style="font-size: 26px; background-color: initial;"><span style="color: rgb(68, 68, 68);">实时关注资讯</span></span></div>
        <div style="text-align: center;"><span style="font-size: 14px; background-color: initial;">——</span></div>
        <div style="text-align: center;"><span style="background-color: initial;">实时关注行内资讯让我们快人一步</span></div>



        <div>
          <div topclassname="top1" topswitch="on" newsid="6" newsname="企业IT规划发展的三个时期" class="J_newsListLine line g_item   fk-newsLineHeight  J_nHover "><div id="lineBody6" class="J_lineBody lineBody newsListLineBody1"><div class="J_titleLine fk-titleLine"><div class="J_newsTitle newsTitle J_noChangeStyle newsListNewsTitle3" style="width: 75%;">
            <div class="J_newsListTopFlag "></div>
            <a class="fk-newsListTitle" hidefocus="true" href="/nd.jsp?fromColId=105&amp;id=6#_np=105_381" target="_blank" title="企业IT规划发展的三个时期">企业IT规划发展的三个时期</a>
          </div>
            <div class="clearfloat"></div></div><div><p class="pic-mixNewsStyleSummary fk-newsListSummary">IT规划不是摆设，它必须在得到切实可行的实施之后，才能发挥出促进业务、提升管理的作用，否则就是一堆废纸。因此，“落地”环节对IT规划关重要。如今，IT规划已经不是个新鲜...</p>
          </div></div></div>


          <div class="J_separatorLine separatorLine g_separator ">---------------------</div>


          <div topclassname="top1" topswitch="on" newsid="5" newsname="网信办等四部门开展隐私条款专项工作：首批针对微信\淘宝等评审" class="J_newsListLine line g_item   fk-newsLineHeight  J_nHover "><div id="lineBody5" class="J_lineBody lineBody newsListLineBody1"><div class="J_titleLine fk-titleLine"><div class="J_newsTitle newsTitle J_noChangeStyle newsListNewsTitle3" style="width: 75%;">
            <div class="J_newsListTopFlag "></div>
            <a class="fk-newsListTitle" hidefocus="true" href="/nd.jsp?fromColId=105&amp;id=5#_np=105_381" target="_blank" title="网信办等四部门开展隐私条款专项工作：首批针对微信\淘宝等评审">网信办等四部门开展隐私条款专项工作：首批针对微信\淘宝等评审</a>
          </div>
            <div class="clearfloat"></div></div><div><p class="pic-mixNewsStyleSummary fk-newsListSummary">7月1日起，《移动智能终端应用软件预置办和分发管理暂行规定》开始实施，要求生产企业和互联网信息提供者应确保除基本功能软件外的移动智能终端应用软件可卸载。现在，继手机...</p>
          </div></div></div>
          <div class="J_separatorLine separatorLine g_separator "></div>
          <div topclassname="top1" topswitch="on" newsid="4" newsname="苹果向诺基亚支付20亿美元，解决专利争端" class="J_newsListLine line g_item   fk-newsLineHeight  J_nHover "><div id="lineBody4" class="J_lineBody lineBody newsListLineBody1"><div class="J_titleLine fk-titleLine"><div class="J_newsTitle newsTitle J_noChangeStyle newsListNewsTitle3" style="width: 75%;">
            <div class="J_newsListTopFlag "></div>
            <a class="fk-newsListTitle" hidefocus="true" href="/nd.jsp?fromColId=105&amp;id=4#_np=105_381" target="_blank" title="苹果向诺基亚支付20亿美元，解决专利争端">苹果向诺基亚支付20亿美元，解决专利争端</a>
          </div>
            <div class="clearfloat"></div></div><div><p class="pic-mixNewsStyleSummary fk-newsListSummary">诺基亚昨日公布了2017年第二季度的财报。财报显示，诺基亚2017年第二季度的运营利润为5.74亿欧元（约合6.7亿美元），同比增长73%，高于分析师预期的4.47亿欧元。据BGR报道...</p>
          </div></div></div>
          <div class="J_separatorLine separatorLine g_separator "></div>
          <div topclassname="top1" topswitch="on" newsid="3" newsname="前苹果高管: 微软本可避免WP失败" class="J_newsListLine line g_item   fk-newsLineHeight  J_nHover "><div id="lineBody3" class="J_lineBody lineBody newsListLineBody1"><div class="J_titleLine fk-titleLine"><div class="J_newsTitle newsTitle J_noChangeStyle newsListNewsTitle3" style="width: 75%;">
            <div class="J_newsListTopFlag "></div>
            <a class="fk-newsListTitle" hidefocus="true" href="/nd.jsp?fromColId=105&amp;id=3#_np=105_381" target="_blank" title="前苹果高管: 微软本可避免WP失败">前苹果高管: 微软本可避免WP失败</a>
          </div>
            <div class="clearfloat"></div></div><div><p class="pic-mixNewsStyleSummary fk-newsListSummary">日前，Medium专栏作者、前苹果高管Jean-Louis Gassée在一篇关于微软Windows Phone的文章表示，微软本来可以避免今天的境地，但是其一直以其固有的以PC为中心的思维来经...</p>
          </div></div></div>
          <div class="J_separatorLine separatorLine g_separator "></div>
          <div topclassname="top1" topswitch="on" newsid="2" newsname="苹果又遭专利诉讼：因Apple TV快速回放功能侵权" class="J_newsListLine line g_item   fk-newsLineHeight  J_nHover "><div id="lineBody2" class="J_lineBody lineBody newsListLineBody1"><div class="J_titleLine fk-titleLine"><div class="J_newsTitle newsTitle J_noChangeStyle newsListNewsTitle3" style="width: 75%;">
            <div class="J_newsListTopFlag "></div>
            <a class="fk-newsListTitle" hidefocus="true" href="/nd.jsp?fromColId=105&amp;id=2#_np=105_381" target="_blank" title="苹果又遭专利诉讼：因Apple TV快速回放功能侵权">苹果又遭专利诉讼：因Apple TV快速回放功能侵权</a>
          </div>
            <div class="clearfloat"></div></div><div><p class="pic-mixNewsStyleSummary fk-newsListSummary">一家位于佛罗里达州的数字视频公司正在就苹果公司第四代Apple TV的Siri功能提起专利诉讼。这家名为CustomPlay的公司称，是他们早开发了Apple TV和Siri正在使用的这一功能...</p>
          </div></div></div>
          <div class="J_separatorLine separatorLine g_separator "></div>
          <div topclassname="top1" topswitch="on" newsid="1" newsname="看3D电影能让你的大脑更灵活" class="J_newsListLine line g_item   fk-newsLineHeight  J_nHover "><div id="lineBody1" class="J_lineBody lineBody newsListLineBody1"><div class="J_titleLine fk-titleLine"><div class="J_newsTitle newsTitle J_noChangeStyle newsListNewsTitle3" style="width: 75%;">
            <div class="J_newsListTopFlag "></div>
            <a class="fk-newsListTitle" hidefocus="true" href="/nd.jsp?fromColId=105&amp;id=1#_np=105_381" target="_blank" title="看3D电影能让你的大脑更灵活">看3D电影能让你的大脑更灵活</a>
          </div>
            <div class="clearfloat"></div></div><div><p class="pic-mixNewsStyleSummary fk-newsListSummary">看3D电影让人享受新奇的视觉体验，英国伦敦戈德史密斯大学一项研究显示，这还有助脑力提升。研究人员招募100多名志愿者，让他们分别观看普通版和3D版的迪士尼影片《超能陆战队》...</p>
          </div></div></div>
          <div class="J_separatorLine separatorLine g_separator  newsListSeparatorLine "></div>



        </div>


      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner2";
export default {
  name: "news",
  components: {
    Banner
  },
  data() {
    return {
      loading: true,
      newsList: [],
      newstype: 1
    };
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$http
        .get(`News?type=${this.newstype}&num=6`)
        .then(response => {
          //console.log(response);
          this.newsList = response.data;
          this.loading = false;
          //window.console.log(this.newsList);
        })
        .catch(function(error) {
          window.console.log(error);
        });
    }
  },
  mounted() {
    // this.loadData();
    this.loading = false;
  },
  watch: {
    // newstype(type) {
    //   window.console.log(type);
    //   this.loadData();
    // }
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.news {
  width: 100%;
  height: 100%;
  //background-color: #14679f;

  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;
    //height: 1600px;

    &-content {
      //width: 1240px;
      //height: 1600px;
      margin: 0 auto;
      background-color: #fff;
      //border: 1px solid red;

      .content-nav {
        width: 400px;
        height: 55px;
        margin: 0 auto;
        display: flex;
        //justify-content: center;
        align-items: center;
        position: relative;
        bottom: 30px;
        border: 1px solid red;

        &-btn {
          width: 50%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e4e4e4;
          transition: all 0.2s;
        }

        .content-nav-active {
          background-color: red;
          color: #fff;
        }
      }

      .content-nav-item {
        width: 1070px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        //border: 1px solid blue;

        .item-list {
          width: 330px;
          height: 500px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 10px 10px;
          //border: 1px solid #15669e;

          &:hover {
            border: 1px solid #fff;
            box-shadow: 0 0 5px 2px #bfd3e0;
          }
          .item-img {
            width: 300px;
            height: 210px;
            background-color: #cecece;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            background-origin: content-box;
          }

          &-title {
            width: 300px;
            height: 60px;
            color: #15669e;
            font-size: 22px;
            padding: 0 10px;
            margin: 20px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            border-left: 1px solid #15669e;
          }

          &-content {
            width: 273px;
            height: 100px;
            font-size: 14px;
            color: gray;

            // 文本长度处理 begin
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            // 文本长度处理 ending
          }

          &-more {
            width: 273px;
            padding-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 12px;
              height: 12px;
            }
            span {
              color: #e13834;
              padding: 0 5px;
            }
          }
        }
      }
    }
  }
  .text-decoration {
    text-decoration: none;
  }

  .g_separator{
    display: block;
    border-style: dashed;
    border-color: rgba(221, 221, 221, 1);
    border-width: 1px;
    border-right: none;
    border-top: none;
    border-left: none;
  }
  .fk-newsListSummary{
    font-size: 14px;
    font-family: 微软雅黑;
    color: rgba(119, 119, 119, 1);
    font-weight: normal;
    text-decoration: none;
    font-style: normal;
  }

  .fk-newsListTitle{
    font-size: 16px;
    font-family: 微软雅黑;
    color: rgba(43, 43, 43, 1);
    font-weight: normal;
    text-decoration: none;
    font-style: normal;
  }

  .separatorLine{
    clear: both;
    height: 1px;
    line-height: 1px;
    margin: 0;
    font-size: 0;
    border-width: 1px;
    border-style: dashed;
    border-top: none;
    border-left: none;
    border-right: none;
  }



  .formMiddleCenter{
    //display: table-cell;
    margin: 0;
    zoom: 1;
    width: 100%;
    *padding: 0;
  }

  .webContainer{
    width: 1200px;
    position: relative;
    //width: 960px;
    padding: 0;
    margin: 0 auto;
    text-align: left;
  }

  .J_separatorLine{
    //border:1px dashed grey;
    height:0;
    margin: 28px 0;
    border-color: rgba(221, 221, 221, 1);

  }
}
</style>